import React, { useState, useEffect, useRef } from "react";
import DevQuestion from "./c_MathQuestion";
import axios from "axios";
import RNavBar from "./r_sat_nav";
import { BASELINE } from "../../util";
import Check_topics from "./check_problems";

const RDevQuiz = ({ id, questionIds, skilldesc, setdashboard, onNext, onBack, onSelectQuestion }) => {
    const boxItemLeftRef = useRef();

    // currentQuestion 상태 (기존 필드들)
    const [currentQuestion, setCurrentQuestion] = useState({
        stem: "",
        prompt: "",
        stimulus: "",
        a: "",
        b: "",
        c: "",
        d: "",
        correct_answer: "",
        rationale: "",
        primary_class_cd_descs: "",
        skill_descs: "",
        tag: "",
        difficultys: "",
        completed: "",
    });

    // 모달 및 사이드바 관련 상태
    const [showModal, setShowModal] = useState(false);
    const [autofillText, setAutofillText] = useState("");
    const [showMemoModal, setShowMemoModal] = useState(false);
    const [memoText, setMemoText] = useState("");
    const [showSidebar, setShowSidebar] = useState(false);

    // katex auto-render 스크립트 로드 (생략된 부분 동일)
    useEffect(() => {
        const script2 = document.createElement("script");
        script2.src =
            "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
        script2.integrity =
            "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
        script2.crossOrigin = "anonymous";
        script2.defer = true;

        script2.onload = () => {
            if (boxItemLeftRef.current && window.renderMathInElement) {
                window.renderMathInElement(boxItemLeftRef.current, {
                    delimiters: [
                        { left: "\\(", right: "\\)", display: false },
                        { left: "\\[", right: "\\]", display: true },
                        { left: "$$", right: "$$", display: false },
                        { left: "$", right: "$", display: false },
                    ],
                    throwOnError: false,
                });
            }
        };

        document.body.appendChild(script2);
        return () => {
            document.body.removeChild(script2);
        };
    }, [
        currentQuestion.stimulus,
        currentQuestion.stem,
        currentQuestion.a,
        currentQuestion.b,
        currentQuestion.c,
        currentQuestion.d,
        currentQuestion.correct_answer,
        currentQuestion.rationale,
        currentQuestion.complete,
    ]);

    // 각 입력값 변경 핸들러 (생략된 부분 동일)
    const handlestem = (value) => {
        setCurrentQuestion((prev) => ({ ...prev, stem: value }));
    };

    const handlestimulus = (value) => {
        setCurrentQuestion((prev) => ({ ...prev, stimulus: value }));
    };

    const handlerationale = (value) => {
        setCurrentQuestion((prev) => ({ ...prev, rationale: value }));
    };

    const handleAutofillSubmit = () => {
        try {
            const data = JSON.parse(autofillText);
            setCurrentQuestion((prev) => ({ ...prev, ...data }));
            setShowModal(false);
            setAutofillText("");
        } catch (error) {
            alert("유효하지 않은 JSON 데이터입니다.");
        }
    };

    useEffect(() => {
        if (questionIds) {
            axios
                .get(BASELINE + "getsatquestionai", { params: { questionIds } })
                .then((response) => {
                    if (response.data.success && response.data.data.length > 0) {
                        const data = response.data.data[0];
                        setCurrentQuestion({
                            stem: data.stem || "",
                            prompt: data.prompt || "",
                            stimulus: data.stimulus || "",
                            a: data.a || "",
                            b: data.b || "",
                            c: data.c || "",
                            d: data.d || "",
                            correct_answer: data.correct_answer || "",
                            rationale: data.rationale || "",
                            primary_class_cd_descs: data.primary_class_cd_descs || "",
                            skill_descs: data.skill_descs || "",
                            tag: data.tag || "",
                            difficultys: data.difficultys || "",
                            completed: data.completed || "",
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching question data:", error);
                });
        }
    }, [questionIds]);

    // Leave Memo Modal 핸들러
    const handleLeaveMemo = () => {
        setShowMemoModal(true);
    };

    // Save button handler
    const handleSave = () => {
        if (window.confirm("The current data will be saved. Do you want to proceed?")) {
            const updatedData = {
                ...currentQuestion,
                questionIds: questionIds,
            };

            axios
                .post(BASELINE + "savesatquestionai", updatedData)
                .then((response) => {
                    if (response.data.success) {
                        alert("Saved successfully.");
                        const currentLATime = getLATimeString();
                        const logMessage = `${id} saved the ${questionIds} at ${currentLATime}`;

                        axios.post(BASELINE + "add/log", {
                            uid: id,
                            question_id: questionIds,
                            log: logMessage,
                            currentLATime: currentLATime,
                        })
                            .then((logResponse) => {
                                if (logResponse.data.success) {
                                } else {
                                    console.error("Failed to save log.");
                                }
                            })
                            .catch((error) => {
                                console.error("Error saving log:", error);
                            });
                    } else {
                        alert("Save failed.");
                    }
                })
                .catch((error) => {
                    console.error("Error saving question:", error);
                    alert("An error occurred during saving.");
                });
        }
    };

    // Mark Complete button handler
    // Helper function to get current LA time in 'YYYY-MM-DD HH:MM:SS' format.
    const getLATimeString = () => {
        const date = new Date().toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" });
        const time = new Date().toLocaleTimeString("en-US", {
            timeZone: "America/Los_Angeles",
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return `${date} ${time}`;
    };

    const handleMarkComplete = () => {
        if (
            window.confirm(
                "The current data will be updated. Do you want to toggle the complete status?"
            )
        ) {
            // Toggle complete status: if currently "1", change to "0", else "1"
            const newCompleteStatus = currentQuestion.completed === "1" ? "0" : "1";
            const updatedData = {
                ...currentQuestion,
                completed: newCompleteStatus,
                questionIds: questionIds,
            };

            axios
                .post(BASELINE + "savesatquestionai", updatedData)
                .then((response) => {
                    if (response.data.success) {
                        alert("Data updated successfully.");
                        setCurrentQuestion(updatedData);

                        // Create log message based on the new status.
                        const statusText = newCompleteStatus === "1" ? "complete" : "not complete";
                        const currentLATime = getLATimeString();
                        // Retrieve the user id from localStorage (assumed to be set during login)
                        const logMessage = `${id} mark ${questionIds} as ${statusText} at ${currentLATime}`;

                        // Call the /add/log API to save the log entry.
                        axios
                            .post(BASELINE + "add/log", {
                                uid: id,
                                question_id: questionIds,
                                log: logMessage,
                                currentLATime: currentLATime,
                            })
                            .then((logResponse) => {
                                if (logResponse.data.success) {
                                } else {
                                    console.error("Failed to save log.");
                                }
                            })
                            .catch((logError) => {
                                console.error("Error saving log:", logError);
                            });
                    } else {
                        alert("Update failed.");
                    }
                })
                .catch((error) => {
                    console.error("Error updating complete status:", error);
                    alert("An error occurred during updating.");
                });
        }
    };



    const handleMemoSubmit = () => {
        // 유효성 검사: questionIds와 memoText가 존재하는지 확인
        if (!questionIds) {
            alert("No question selected.");
            return;
        }
        if (!memoText.trim()) {
            alert("Please enter a memo.");
            return;
        }

        // 예시: userid를 로컬 스토리지에서 가져오거나, 다른 방식으로 할당합니다.
        const userid = localStorage.getItem("userid") || "defaultUser";

        // API 호출: add/note 엔드포인트에 데이터 전송
        axios
            .post(BASELINE + "add/note", {
                question_id: questionIds,
                note: memoText,
                userid: id,
                skilldesc: skilldesc
            })
            .then((response) => {
                if (response.data.success) {
                    alert("Note added successfully.");
                } else {
                    alert("Failed to add note.");
                }
            })
            .catch((error) => {
                console.error("Error adding note:", error);
                alert("Error adding note.");
            });

        // 모달 닫기 및 입력값 초기화
        setShowMemoModal(false);
        setMemoText("");
    };

    useEffect(() => {
        if (showMemoModal) {
            const handleKeyDown = (e) => {
                if (e.key === "Escape") {
                    setShowMemoModal(false);
                    setMemoText("");
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return () => {
                window.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [showMemoModal]);

    return (
        <div className="fbg-white">
            <RNavBar
                id={id}
                skilldesc={skilldesc}
                onLeaveMemo={handleLeaveMemo}
                onToDashboard={() => setdashboard(1)}
                onSave={handleSave}
                onComplete={handleMarkComplete}
                onToggle={() => setShowSidebar(!showSidebar)}
                onNext={onNext}
                onBack={onBack}
                questionIds={questionIds}
            />

            {/* Optional Sidebar */}
            <div className="flex">
                {showSidebar && (
                    <div className="w-1/5 bg-gray-200 p-4">
                        <Check_topics
                            skilldesc={skilldesc}
                            roww={1}
                            questionIds={questionIds}
                            onSelectQuestion={onSelectQuestion}
                        />
                    </div>
                )}
                <div className={showSidebar ? "w-4/5" : "w-full"}>
                    {/* Autofill Modal */}
                    {showModal && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded shadow-lg w-[80%] max-w-lg">
                                <textarea
                                    className="w-full h-64 border border-gray-300 p-2"
                                    placeholder="Insert the JSON data"
                                    value={autofillText}
                                    onChange={(e) => setAutofillText(e.target.value)}
                                />
                                <div className="flex justify-end mt-2 gap-2">
                                    <button
                                        onClick={() => {
                                            setShowModal(false);
                                            setAutofillText("");
                                        }}
                                        className="bg-gray-500 text-white p-2 rounded"
                                    >
                                        Close
                                    </button>
                                    <button
                                        onClick={handleAutofillSubmit}
                                        className="bg-green-500 text-white p-2 rounded"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Leave Memo Modal */}
                    {showMemoModal && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded shadow-lg w-[80%] max-w-lg">
                                <h3 className="text-xl font-bold mb-4">Leave Memo</h3>
                                <p className="mb-2">
                                    <strong>Question IDs:</strong> {questionIds}
                                </p>
                                <textarea
                                    className="w-full h-40 border border-gray-300 p-2 mb-4"
                                    placeholder="Write your memo here..."
                                    value={memoText}
                                    onChange={(e) => setMemoText(e.target.value)}
                                />
                                <div className="flex justify-end gap-2">
                                    <button
                                        onClick={() => {
                                            setShowMemoModal(false);
                                            setMemoText("");
                                        }}
                                        className="bg-gray-500 text-white p-2 rounded"
                                    >
                                        Close
                                    </button>
                                    <button
                                        onClick={handleMemoSubmit}
                                        className="bg-green-500 text-white p-2 rounded"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* DevQuestion 컴포넌트 */}
                    <DevQuestion
                        currentQuestion={currentQuestion}
                        stimulus={currentQuestion.stimulus}
                        stem={currentQuestion.stem}
                        a={currentQuestion.a}
                        b={currentQuestion.b}
                        c={currentQuestion.c}
                        d={currentQuestion.d}
                        correct_answer={currentQuestion.correct_answer}
                        rationale={currentQuestion.rationale}
                    />

                    {/* 좌측 편집 영역 */}
                    <div className="flex z-[10] mt-[10px]">
                        <div className="flex flex-col justify-start w-[50%]">
                            <div>
                                <p className="bg-yellow-300">Edit question stem here</p>
                                <textarea
                                    value={currentQuestion.stem}
                                    onChange={(e) => handlestem(e.target.value)}
                                    className={`w-full ${currentQuestion.stem ? "h-[500px]" : "h-[20px]"
                                        } p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300`}
                                    placeholder="Edit question stem here"
                                />

                                <p>Edit question stimulus here</p>
                                <textarea
                                    value={currentQuestion.stimulus}
                                    onChange={(e) => handlestimulus(e.target.value)}
                                    className={`w-full ${currentQuestion.stimulus ? "h-[500px]" : "h-[20px]"
                                        } p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300 mt-2`}
                                    placeholder="Edit question stimulus here"
                                />
                            </div>
                        </div>

                        {/* 오른쪽: 옵션 및 정답 편집 영역 */}
                        <div className="flex flex-col gap-2 my-4 w-[50%]">
                            <p className="mt-2">Answer A:</p>
                            <textarea
                                className="border border-gray-300 p-2 w-full"
                                value={currentQuestion.a}
                                onChange={(e) =>
                                    setCurrentQuestion((prev) => ({
                                        ...prev,
                                        a: e.target.value,
                                    }))
                                }
                                placeholder="Edit option A"
                            />

                            <p className="mt-2">Answer B:</p>
                            <textarea
                                className="border border-gray-300 p-2 w-full"
                                value={currentQuestion.b}
                                onChange={(e) =>
                                    setCurrentQuestion((prev) => ({
                                        ...prev,
                                        b: e.target.value,
                                    }))
                                }
                                placeholder="Edit option B"
                            />

                            <p className="mt-2">Answer C:</p>
                            <textarea
                                className="border border-gray-300 p-2 w-full"
                                value={currentQuestion.c}
                                onChange={(e) =>
                                    setCurrentQuestion((prev) => ({
                                        ...prev,
                                        c: e.target.value,
                                    }))
                                }
                                placeholder="Edit option C"
                            />

                            <p className="mt-2">Answer D:</p>
                            <textarea
                                className="border border-gray-300 p-2 w-full"
                                value={currentQuestion.d}
                                onChange={(e) =>
                                    setCurrentQuestion((prev) => ({
                                        ...prev,
                                        d: e.target.value,
                                    }))
                                }
                                placeholder="Edit option D"
                            />

                            <p className="mt-2">Correct Answer:</p>
                            <textarea
                                className="border border-gray-300 p-2 w-full"
                                value={currentQuestion.correct_answer}
                                onChange={(e) =>
                                    setCurrentQuestion((prev) => ({
                                        ...prev,
                                        correct_answer: e.target.value,
                                    }))
                                }
                                placeholder="Edit correct answer"
                            />
                        </div>
                    </div>

                    {/* 하단: 질문 해설 (rationale) 편집 영역 */}
                    <p className="font-bold">Question Rationale</p>
                    <div
                        className="ml-[20px] flex z-[10] mt-[10px] gap-2 p-2"
                        id="box-item-left"
                        ref={boxItemLeftRef}
                    >
                        <div className="max-w-[50%]">
                            <div
                                className="min-h-[40%] overflow-y-auto overflow-x-hidden my-list-style"
                                dangerouslySetInnerHTML={{ __html: currentQuestion.rationale }}
                            />
                        </div>

                        <div className="w-[50%]">
                            <textarea
                                value={currentQuestion.rationale}
                                onChange={(e) => handlerationale(e.target.value)}
                                className="h-[100%] w-full p-2 overflow-y-auto overflow-x-hidden my-list-style border border-gray-300"
                                placeholder="Edit question rationale here"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RDevQuiz;
